<template>

  <div class="tabs">

    <div class="tabs__nav">
    
      <div
        v-for="(tab, index) in tabs"
        @click="onClickNavItem(index)"
        :class="{ 'tabs__nav-item_active' : index === activeIndex }"
        class="tabs__nav-item"
      >{{ tab.name }}</div>
    
    </div>
    
    <div class="tabs__items">
      
      <slot :activeIndex="activeIndex"></slot>

    </div>

  </div>

</template>

<script>
  export default {
    name: 'TabsList',

    data() {
      return {
        activeIndex: 0,
        tabs: [],
      };
    },

    watch: {
      activeIndex(value) {
        this.$emit('change', value);
      },
    },

    mounted() {
      console.log(this.$children);
      this.tabs = this.$children;
    },

    methods: {
      onClickNavItem(index) {
        this.activeIndex = index;
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/TabsList.vue